import React from 'react'
import Navbar from '../components/Navbar'
import Baner from '../components/Baner'
import bg from '../assets/bg-personalmedia.jpg'
import Footer from '../components/Footer'
import {AiOutlinePhone} from 'react-icons/ai'
import {BiMailSend} from 'react-icons/bi'

const PersonalMedia = () => {

  const indywidualny = [
    {
      id: 1,
      text: "JOB HUNTER",
      text2: "Pomoc w poszukiwaniu wymarzonej pracy, tworzenie ścieżki kariery",
    }, {
      id: 2,
      text: "JOB INTERVIEW",
      text2: "Przygotowanie kandydata do rozmowy rekrutacyjnej, pierwszej pracy, czy stażu",
    }, {
      id: 3,
      text: "JOB DOCUMENTS",
      text2: "Tworzenie dokumentów aplikacyjnych: CV i list motywacyjny",
    }, 
  ]

  const firmowy = [
    {
      id: 1,
      text: "HR Business Partner ",
      text2: "wynajęcie Eksperta na wybrany okres czasu z ustaleniem zadań i priorytetów dla Klienta",
    }, {
      id: 2,
      text: "Doradztwo dla Klienta",
      text2: "w wybranych zagadnienach z obszaru personalnego",
    }, {
      id: 3,
      text: "Headhunter freelancer",
      text2: "pozyskanie dla Klienta właściwego kandydata",
    }, {
      id: 4,
      text: "Prowadzenie procesu rekrutacji i selekcji",
      text2: "",
    }, {
      id: 5,
      text: "Onboarding pracowników",
      text2: "",
    }, {
      id: 6,
      text: "Assessment Centre",
      text2: "",
    }, {
      id: 7,
      text: "Development Centre",
      text2: "",
    }, 
  ]

  const szkolenia = [
    {
      id: 1,
      text: "Zarządzanie czasem i efektywnością",
    },{
      id: 2,
      text: "Budowanie marki własnej oraz profesjonalnego wizerunku",
    },{
      id: 3,
      text: "Autoprezentacja – klucz do sukcesu Jak być szefem i człowiekiem",
    },{
      id: 4,
      text: "Savoir vivre w biznesie",
    },{
      id: 5,
      text: "Komunikacja w środowisku zawodowym",
    },{
      id: 6,
      text: "Powiedz życiu sprawdzam – coaching personalny",
    },
  ]

  return (
    <div>
      <Navbar />
      <Baner bg={bg} text="PERSONAL MEDIA" text2=""/>
      <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
          <div className='text-center mx-5'>
            <div className='pt-10'>
              <h2 className='text-xl sm:text-3xl font-semibold text-[#4C4C9B]'>PAKIET INDYWIDUALNY</h2>
              {indywidualny.map((item) => (
                <div className='pt-5'>
                  <h3 className='text-xl font-semibold'>{item.text}</h3>
                  <p>{item.text2}</p>
                </div>
              ))}
            </div>
            <div className='py-32'>
              <h2 className='text-xl sm:text-3xl font-semibold text-[#4C4C9B]'>PAKIET FIRMOWY</h2>
              {firmowy.map((item) => (
                <div className='pt-5'>
                  <h3 className='text-xl font-semibold'>{item.text}</h3>
                  <p>{item.text2}</p>
                </div>
              ))}
            </div>
            <div>
              <h2 className='text-xl sm:text-3xl font-semibold text-[#4C4C9B]'>PAKIET SZKOLENIOWY</h2>
              {szkolenia.map((item) => (
                <div className='pt-5'>
                  <h3 className='text-xl'>{item.text}</h3>
                </div>
              ))}
            </div>

            <div className='mt-32 bg-[#4C4C9B] text-white py-6 rounded-2xl hover:shadow-lg duration-300'>
                <h2 className='text-2xl'>KONTAKT DO EXPERTA</h2>
                <h3 className='text-lg sm:text-xl font-semibold py-5'>Agnieszka Kochanowska-Onichimowska</h3>
                <div className='mx-auto justify-center flex'>
                  <div>
                    <div className='flex pr-10'>
                        <AiOutlinePhone size={25}/>
                        <p className='pl-2'>personalmediagdansk@gmail.com</p>
                    </div>
                    <div className='flex'>
                      <BiMailSend size={25}/>
                      <p className='pl-2'>664-358-958</p>
                    </div>
                  </div>
                </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default PersonalMedia